import { createAction, props } from "@ngrx/store";
import { PasswordRecoveryDTO } from "src/app/models/login/PasswordRecoveryDTO";
import { PasswordResetDTO } from "src/app/models/login/PasswordResetDTO";
import { User } from "src/app/models/user";
import { UserSession } from "src/app/models/user-session";

export const loginSuccess = createAction(
  "[Login] Login Action Success",
  props<{ authenticatedUser: UserSession }>()
);
export const logOut = createAction(
  "[Login] LogOut Action"
);
export const logOutSuccess = createAction(
  "[Login] LogOut Action Success",
  props<{ isPasswordRecovery: boolean }>()
);
export const authenticate = createAction(
  "[Login] Authenticate Action",
  props<{ user: User }>()
);
export const loginFailure = createAction(
  "[Login] Login Action Failure",
  props<{ error: Error }>()
);
export const openExpired = createAction("[Login] Session Expired open dialog");
export const closeExpired = createAction(
  "[Login] Session Expired close dialog"
);
export const recoverPassword = createAction(
  "[Login] Password Recovery Action",
  props<{ passwordRecovery: PasswordRecoveryDTO }>()
);
export const resetPassword = createAction(
  "[Login] Password Reset Action",
  props<{ passwordReset: PasswordResetDTO; tokenQuery: string }>()
);
export const recoverPasswordSuccess = createAction(
  "[Login] Password Recover Success Action"
);
export const resetPasswordSuccess = createAction(
  "[Login] Password Reset Success Action"
);
export const getLocales = createAction(
  "[Login] Get All Locales Action",
  props<{ options: any }>()
);
export const loadLocales = createAction(
  "[Login] Load All Locales Action",
  props<{ response: any }>()
);
export const setLoadingEndState = createAction(
  "[Login] Set Login Loading End State Action"
);
